'use client';

export default function ProjectStat({ className, children }) {
  return (
    <div className={` bg-base-200 border border-base-content px-2 py-1 rounded ${className || ''}`}>
      {children}
    </div>
  );
}
